<template>
  <div id="search-list" style="position: relative">
    <v-container v-if="showSearchBar" id="containerSearch">
      <v-layout row v-click-outside="hideList" id="layoutSearch">
        <div class="card--flex-toolbar" id="searchWrapper">
          <div class="search-input-wrapper">
            <div class="search-div">
              <VTextFieldExtended
                :placeholder="$tf('SearchInIdonia')"
                :loading="loading"
                autocomplete="off"
                :autofocus="forceFocus"
                id="searchField"
                ref="search"
                flat
                light
                name="search"
                v-model="computedSearchInput"
                hide-details
                single-line
                @focus="searchFocus = true; $emit('focus')"
                @blur="onBlur"
                @keyup.enter="onEnter"
                prepend-icon="search"
                :suffix="suffixLabel"
              />
              <v-btn
                style="margin: 0"
                @click="showAdvancedSearch = !showAdvancedSearch"
                icon
                small
                class="primary--text"
              >
                <v-badge
                  color="info"
                  overlap
                  v-model="showSearchBadge"
                >
                  <template slot="badge">
                    <span>{{$store.getters['search/searchNumber']}}</span>
                  </template>
                  <v-icon>tune</v-icon>
                </v-badge>
              </v-btn>
            </div>
          </div>
          <v-list
              class="search"
              v-if="showSearchList"
              id="searchList"
              light
              two-line
              subheader>
            <!--<v-subheader light inset>{{$tf('Results:')}}</v-subheader>-->
            <v-list-tile v-for="file in searchResults" :key="file.id_file" avatar @click="goToFile(file)">
              <v-list-tile-avatar>
                <avatar v-if="file.thumbnail !== notFoundIcon"
                        :color="file.color? file.color : 'grey'"
                        :avatar="file.thumbnail"

                        :type="file.type"
                        :size="34"/>
                <v-icon v-else :class="iconClass(file.color)">{{ file.thumbnail }}</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ file.name }}</v-list-tile-title>
                <v-list-tile-sub-title>{{file.named_path}}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon ripple>
                  <v-icon color="grey lighten-1">arrow_forward_ios</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </div>
      </v-layout>
    </v-container>
    <advanced-search
      v-if="showAdvancedSearch"
      @close="showAdvancedSearch=false"
      @clear="clearAdvancedSearch"
      @search="doAdvancedSearch"
    />
  </div>
</template>

<script>
  import Api from '../../store/idonia-api/api.js'
  import { debounce } from 'lodash'
  import VTextFieldExtended from '~/components/vuetify/VTextFieldExtended.vue'
  import AdvancedSearch from '~/components/header/AdvancedSearch.vue'
  import bus from '~/bus'
  import {useStream} from '~/commons/stream'
  import { setTimeoutAsPromise } from '~/store/idonia-api/dialog'

const MIN_CHARS_SEARCH = 3
const { getStreamEventName } = useStream()
  export default {
    name: 'search-list',
    components: {
      VTextFieldExtended,
      AdvancedSearch
    },
    props: {
      forceFocus: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        searchFocus: false,
        searchInput: '',
        notFoundIcon: 'sentiment_dissatisfied',
        previousRequest: null,
        loadingState: [],
        searchResults: [],
        showAdvancedSearch: false,
        overlappingBlur: false
      }
    },
    computed: {
      loading () {
        return this.loadingState.length > 0
      },
      showSearchBar: function () {
        return this.$store.getters['session/isAuthenticated'] &&
          (this.$route.path.substring(1, 5) !== 'filefile' || this.$vuetify.breakpoint.smAndUp)
      },
      showSearchList () {
        return this.searchResults.length > 0
      },
      suffixLabel () {
        return this.searchInput.length < MIN_CHARS_SEARCH && this.searchFocus
          ? this.$tf('SearchInIdoniaHint').toLowerCase()
          : ''
      },
      showSearchBadge () {
        return this.$store.getters['search/searchNumber'] > 0
      },
      computedSearchInput: {
        get: function () {
          return this.searchInput
        },
        set: function (newVal) {
          this.searchInput = newVal
        }
      }
    },
    watch: {
      showAdvancedSearch (val) {
        if (!val && this.searchInput === '') {
          this.onBlur()
        }
      },
      searchInput: debounce(async function (val) {
        if (val === '') {
          this.hideList()
        } else if (val.length >= MIN_CHARS_SEARCH) {
          await this.doSearch()
        }
      }, 1000)
    },
    methods: {
      onSearchResults (data) {
        if (data && data.results) {
          this.searchResults = this.searchResults.filter(item => item.type !== 'notFound')
          this.searchResults.push(...data.results)
        }
      },
      async doSearch () {
        if (!this.$store.getters['search/checkSearchAmongGroups']) {
          return
        }
        this.searchResults = []
        if (this.searchInput && this.searchInput !== '') {
          this.loadingState.push(0)
          let query = this.searchInput.replace(/ +(?= )/g, '').trim()
          let asPayload
          if (this.hasSpecialCharacters(query)) {
            asPayload = query
            query = ''
          }
          const endpoint = 'file/full-search/' + query + (query ? '/' : '')
          bus.$on(getStreamEventName(endpoint), this.onSearchResults)

          try {
            await Api.fetchStream(endpoint, {
              before: request => {
                if (this.previousRequest) {
                  this.previousRequest.abort()
                }
                this.previousRequest = request
              },
              fetch: { method: 'POST' },
              data: JSON.stringify({
                actor_target_id: 'account/' + this.$store.getters['session/accountUUID'],
                filters: this.$store.getters['search/formattedFilters'],
                search_among_groups: this.$store.getters['search/getSearchAmomgGroups'],
                free_text: asPayload
              })
            })

            bus.$emit('analytics', {
              action: 'header-search',
              arguments: {
                query: query || asPayload
              }
            })
          } catch (error) {
            this.$store.dispatch('feedback/addSnack', { text: error, type: 'error' })
          } finally {
            this.loadingState.pop()
            bus.$off(getStreamEventName(endpoint), this.onSearchResults)
            if (this.searchResults.length === 0 && !this.loading) {
              this.searchResults = [{
                name: this.$tf('File not found'),
                thumbnail: this.notFoundIcon,
                color: 'red',
                matchtext: '',
                type: 'notFound'
              }]
            }
          }
        }
      },
      async doAdvancedSearch (payload) {
        this.showAdvancedSearch = false
        this.searchResults = []
        if (payload && Object.keys(payload).length > 0) {
          if (payload.currentPathOnly) {
            if (this.$route.name === 'myspace') {
              payload.parentId = 'myspace'
            } else if (this.$route.name === 'file-view') {
              payload.parentId = 'oldFileId:' + this.$route.params.id
            }
          } else {
            delete payload.parentId
          }
          this.$store.commit('color/setFilters', [])
          this.$store.dispatch('search/setSearchFields', payload)
          this.goToMySearch()
        }
      },
      clearAdvancedSearch () {
        this.showAdvancedSearch = false
        this.$store.commit('color/setFilters', [])
        this.$store.dispatch('search/clearSearch')
        this.$router.push('/myspace')
      },
      iconClass (color) {
        return color + ' lighten-1 white--text\''
      },
      goToFile (file) {
        this.hideList()
        if (file.thumbnail !== this.notFoundIcon) {
          this.$router.push('/file/' + file.id_file)
        }
      },
      hideList () {
        this.searchResults = []
        this.searchInput = ''
      },
      hasSpecialCharacters (str) {
        return this.$store.getters['search/hasSpecialCharacters'](str)
      },
      onBlur (event) {
        if (!this.overlappingBlur) {
          this.overlappingBlur = true
          setTimeoutAsPromise(() => {
            if (!this.showAdvancedSearch) {
              this.searchFocus = false
              this.searchInput = ''
              this.$emit('unfocused')
            }
          }, 300).then(() => {
            this.overlappingBlur = false
          })
        }
      },
      onEnter () {
        this.searchResults = []
        if (this.searchInput !== '') {
          this.$store.dispatch('search/setSearchInput', this.searchInput)
          this.goToMySearch()
          this.searchIput = this.$store.state.search.searchInput
        }
      },
      goToMySearch () {
        this.$store.dispatch('search/clearOffsets')
        if (this.$route.name === 'mysearch') {
          bus.$emit('reloadFiles')
        }
        this.$router.push('/mysearch')
      }
    },
    directives: {
      'click-outside': {
        bind: function (el, binding, vNode) {
          // Provided expression must evaluate to a function.
          if (typeof binding.value !== 'function') {
            const compName = vNode.context.name
            let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
            if (compName) { warn += `Found in component '${compName}'` }

            console.warn(warn)
          }
          // Define Handler and cache it on the element
          const bubble = binding.modifiers.bubble
          const handler = (e) => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
              binding.value(e)
            }
          }
          el.__vueClickOutside__ = handler

          // add Event Listeners
          document.addEventListener('click', handler)
        },

        unbind: function (el, binding) {
          // Remove Event Listeners
          document.removeEventListener('click', el.__vueClickOutside__)
          el.__vueClickOutside__ = null
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.search-input-wrapper {
  /deep/ {
    .input-group--text-field__suffix {
      font-size: 0.95em;

      @media screen and (max-width: 660px) {
        display: none;
      }
    }
  }
}
</style>

<style scoped>
  .search-div {
    display: -webkit-box !important;
    -webkit-box-pack: justify;
  }

  .search-input-wrapper {
    border-bottom: 2px solid var(--primary_text);
    background-color: #fff;
    border-radius: 2px;
    padding: .5rem;
  }

  #searchWrapper {
    z-index: 200;
    /* width: 40vw; */
    opacity: .8;
    transition: .2s;
    width: 100%;
  }

  #searchList {
    box-shadow: 0 12px 16px rgba(0, 0, 0, 0.16);
    margin: 0;
    padding: 0;
    position: fixed;
    max-width: min(85vw, 800px);
    overflow-y: auto;
    max-height: 100vh;
  }

  #searchWrapper:hover {
    opacity: 1;
    transition: .2s;
  }


  #containerSearch {
    padding: 0;
  }

  @media screen and (max-width: 1100px) {
    #searchWrapper {
      /* width: 40vw; */
    }
  }

  @media screen and (min-width: 960px) {
    #searchWrapper {
      /* margin-top: 8px; */
    }
  }

  @media screen and (max-width: 412px) {
    #containerSearch {
      /* margin-top: 4px; */
    }
  }

  /*----IExplorer----*/
  @media screen and (min-width: 961px) and (-ms-high-contrast: none) {
    *::-ms-backdrop,  #searchWrapper {
      width: 40vw
    }
    *::-ms-backdrop, #containerSearch {
      position: absolute;
      top: 10px;
      left: 300px;
    }
  }

  @media screen and (min-width: 412px) and (max-width: 960px) and (-ms-high-contrast: none) {
    *::-ms-backdrop, #containerSearch {
      position: absolute;
      top: 0px;
      max-width: 360px;
      margin-left: 16vw;

    }
  }

  @media screen and (max-width: 412px) and (-ms-high-contrast: none) {
    *::-ms-backdrop, #containerSearch {
      position: absolute;
      top: 0px;
      max-width: 260px;
      margin-left: 5vw;
    }
  }
  @media only screen and (max-width: 600px) {
    .search-div {
      max-width: calc(100% - 25px) !important;
    }
  }

  .input-group__details {
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/header/SearchList.vue